import "./MonitoreoCatalogo.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { MonitoreoPlagaEnfermedadResponse } from "../../../shared/response/comun/MonitoreoPlagaEnfermedadResponse";
import { MonitoreoPlagaEnfermedadService } from "../../../shared/services/comun/MonitoreoPlagaEnfermedadService";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";

export class PlagasCatalogoPage extends BasePageComponent {
  private _all:      MonitoreoPlagaEnfermedadResponse[] = [];
  private _filtered: MonitoreoPlagaEnfermedadResponse[] = [];

  private _tbody!:   HTMLTableSectionElement;
  private _totEl!:   HTMLSpanElement;
  private _search!:  HTMLInputElement;
  private _fGrupo!:  HTMLSelectElement;
  private _fTipo!:   HTMLSelectElement;

  public getAppRoute(): string { return "/monitoreo/plagas"; }
  public getPageTitle(): string | null { return "Catálogo de plagas"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page mon-page";
    pageContent.innerHTML = `
      <div class="mon-content">
        <div class="mon-pg-hd">
          <div>
            <div class="mon-pg-ey">Monitoreo · Catálogo</div>
            <div class="mon-pg-ti">Catálogo de plagas y enfermedades</div>
            <div class="mon-pg-su">Umbrales y clasificación por tipo de monitoreo</div>
          </div>
        </div>

        <div class="mon-frow">
          <div class="mon-sw">
            <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
            <input class="mon-si" id="mon-search" placeholder="Buscar nombre común o técnico…">
          </div>
          <select class="mon-fsel" id="mon-filter-grupo"><option value="">Todos los grupos</option></select>
          <select class="mon-fsel" id="mon-filter-tipo"><option value="">Todos los tipos</option></select>
          <span class="mon-ftot" id="mon-tot"></span>
        </div>

        <div class="mon-tbl-wrap">
          <table class="mon-tbl">
            <thead>
              <tr>
                <th>Grupo</th>
                <th>Nombre común</th>
                <th>Nombre técnico</th>
                <th>Tipo monitoreo</th>
                <th style="width:90px">Rango bajo</th>
                <th style="width:90px">Rango medio</th>
                <th style="width:80px">Crítico</th>
                <th>Lógica umbral</th>
              </tr>
            </thead>
            <tbody id="mon-tbody">
              <tr><td colspan="8" class="mon-empty">Cargando…</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    `;

    this._tbody  = document.getElementById("mon-tbody")! as HTMLTableSectionElement;
    this._totEl  = document.getElementById("mon-tot")!;
    this._search = document.getElementById("mon-search")! as HTMLInputElement;
    this._fGrupo = document.getElementById("mon-filter-grupo")! as HTMLSelectElement;
    this._fTipo  = document.getElementById("mon-filter-tipo")! as HTMLSelectElement;

    this._search.oninput  = () => this._filterAndRender();
    this._fGrupo.onchange = () => this._filterAndRender();
    this._fTipo.onchange  = () => this._filterAndRender();

    void this._loadData();
  }

  protected override beforeDispose(): void {}

  private async _loadData(): Promise<void> {
    try {
      const items = await MonitoreoPlagaEnfermedadService.instance.get();
      this._all = items
        .filter((p) => !p.isEliminado)
        .sort((a, b) =>
          (a.grupo || "").localeCompare(b.grupo || "") || Number(a.orden) - Number(b.orden),
        );
      this._populateFilters();
      this._filterAndRender();
    } catch (error) {
      errorMessageComponent.addError("Error al cargar catálogo de plagas", (error as Error).message);
      this._tbody.innerHTML = `<tr><td colspan="8" class="mon-empty">Error al cargar</td></tr>`;
    }
  }

  private _populateFilters(): void {
    const grupos = [...new Set(this._all.map((p) => p.grupo).filter(Boolean))].sort();
    const tipos  = [...new Set(this._all.map((p) => p.tipoMonitoreo).filter(Boolean))].sort();
    this._fGrupo.innerHTML = `<option value="">Todos los grupos</option>` +
      grupos.map((g) => `<option value="${this._esc(g)}">${this._esc(g)}</option>`).join("");
    this._fTipo.innerHTML = `<option value="">Todos los tipos</option>` +
      tipos.map((t) => `<option value="${this._esc(t)}">${this._esc(t)}</option>`).join("");
  }

  private _filterAndRender(): void {
    const q  = this._search.value.toLowerCase().trim();
    const fg = this._fGrupo.value;
    const ft = this._fTipo.value;

    this._filtered = this._all.filter((p) => {
      const matchQ = !q
        || (p.nombreComun || "").toLowerCase().includes(q)
        || (p.nombreTecnico || "").toLowerCase().includes(q);
      const matchG = !fg || p.grupo === fg;
      const matchT = !ft || p.tipoMonitoreo === ft;
      return matchQ && matchG && matchT;
    });
    this._renderTable();
  }

  private _renderTable(): void {
    const list = this._filtered;
    this._totEl.textContent = `${list.length} plaga${list.length === 1 ? "" : "s"}`;

    if (list.length === 0) {
      this._tbody.innerHTML = `<tr><td colspan="8" class="mon-empty">Sin resultados</td></tr>`;
      return;
    }

    this._tbody.innerHTML = list.map((p) => `
      <tr>
        <td><span class="mon-pill g">${this._esc(p.grupo || "—")}</span></td>
        <td>${this._esc(p.nombreComun || "—")}</td>
        <td class="mon-tecnico">${this._esc(p.nombreTecnico || "—")}</td>
        <td>${this._esc(p.tipoMonitoreo || "—")}</td>
        <td class="mon-num">${p.rangoBajo}</td>
        <td class="mon-num">${p.rangoMedio}</td>
        <td>${p.isCritico ? `<span class="mon-pill crit">Crítico</span>` : "—"}</td>
        <td>${this._esc(p.logicaUmbral || "—")}</td>
      </tr>`).join("");
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
